export default __webpack_public_path__ + "static/media/sidebar_reset.39a3d43d.svg";